import axios from 'axios';
import {LoadAsset} from './LoadAsset.class';

export class StyleLoadAsset extends LoadAsset {
  public chapterId;

  public result?: string;

  constructor({url, chapterId}: {url: string; chapterId: number}) {
    super({type: 'Style', url});

    this.chapterId = chapterId;
  }

  load = async () => {
    try {
      const {data: plainText} = await axios.get(this.url, {
        headers: {'Content-Type': 'text/plain'},
        withCredentials: true,
      });
      this.result = plainText;
    } catch (error) {
      this.error = error;
    }
  };
}
